// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__JIZxX","row":"styles-m__row__2IY5o","button-container":"styles-m__button-container__is4B3","issue":"styles-m__issue__2YYA8"};